import React from 'react';
import { types, Instance } from 'mobx-state-tree';

import App from '@store/app';
import Ui from '@store/ui';
import User from '@store/user';
import KushkiStore, { IKushkiStore } from '@store/kushki';
import DLocalStore, { IDLocalStore } from '@store/dlocal';
import OpenPayStore, { OpenPayStore as IOpenPayStore } from '@store/openPay';
import CheckoutStore, { ICheckoutStore } from '@store/checkout';
import PaymentLinkStore, { IPaymentLinkStore } from '@store/paymentLink';
import ArcusStore, { IArcusStore } from '@store/arcus';
import FintocStore, { IFintocStore } from '@store/fintoc';
import MonatoStore, { IMonatoStore } from '@store/monato';
import FiservStore, { IFiservStore } from '@store/fiserv';
import BlumonStore, { IBlumonStore } from '@store/blumon';
import AccountsPayableLinkStore, { IAccountsPayableLinkStore } from '@store/accountsPayableLink';
import RedPayStore, { IRedPayStore } from '@store/redPay';
import BelvoStore, { IBelvoStore } from '@store/belvo';
import SuraStore, { ISuraStore } from '@store/sura';
import StripeStore, { IStripeStore } from '@store/stripe';

export const GlobalStore = types.model({
  app: App,
  user: User,
  ui: Ui,
  kushki: KushkiStore,
  dlocal: DLocalStore,
  arcus: ArcusStore,
  fintoc: FintocStore,
  monato: MonatoStore,
  links: PaymentLinkStore,
  checkout: CheckoutStore,
  openPay: OpenPayStore,
  fiserv: FiservStore,
  blumon: BlumonStore,
  accountsPayableLink: AccountsPayableLinkStore,
  redPay: RedPayStore,
  belvo: BelvoStore,
  sura: SuraStore,
  stripe: StripeStore,
});

export interface IGlobalStore {
  app: Instance<typeof App>;
  user: Instance<typeof User>;
  ui: Instance<typeof Ui>;
  kushki: IKushkiStore;
  dlocal: IDLocalStore;
  arcus: IArcusStore;
  fintoc: IFintocStore;
  monato: IMonatoStore;
  fiserv: IFiservStore;
  blumon: IBlumonStore;
  links: IPaymentLinkStore;
  checkout: ICheckoutStore;
  openPay: IOpenPayStore;
  accountsPayableLink: IAccountsPayableLinkStore;
  redPay: IRedPayStore;
  belvo: IBelvoStore;
  sura: ISuraStore;
  stripe: IStripeStore;
}

export type TPartialGlobalStore = {
  [K in keyof IGlobalStore]?: Partial<IGlobalStore[K]>;
};

const store: Instance<typeof GlobalStore> = GlobalStore.create({
  app: App.create({
    toastType: 'success',
  }),
  ui: Ui.create({}),
  user: User.create({
    firstName: 'Oyster',
    lastName: 'Developer',
  }),
  kushki: KushkiStore.create({}),
  dlocal: DLocalStore.create({}),
  arcus: ArcusStore.create({}),
  fintoc: FintocStore.create({}),
  monato: MonatoStore.create({}),
  fiserv: FiservStore.create({}),
  blumon: BlumonStore.create({}),
  links: PaymentLinkStore.create({}),
  openPay: OpenPayStore.create({}),
  checkout: CheckoutStore.create({}),
  accountsPayableLink: AccountsPayableLinkStore.create({}),
  redPay: RedPayStore.create({}),
  belvo: BelvoStore.create({}),
  sura: SuraStore.create({}),
  stripe: StripeStore.create({}),
});

export const StoreContext = React.createContext(store);

export default store;
